<template>
  <div
    class="contact-selector"
    :class="{
      missing:
        !classified.profil_email &&
        (contactFocused || showWarnings),
    }"
  >
    <label for="title">
      <strong>Email de contact (non visible sur l'annonce) *</strong>
    </label>
    <div class="form-container">
      <input
        type="email"
        v-model="classified.profil_email"
        name="profil_email"
        id="profil_email"
        @blur="contactFocused = true"
      />
      <span
        class="info"
        v-tooltip="{
          content: 'Vous devez indiquer une adresse email',
          trigger: 'click',
          hideOnTargetClick: true,
        }"
        >i</span
      >
    </div>
    <div class="required" v-if="(contactFocused && !classified.profil_email) || (showWarnings && !classified.profil_email)">
      Champ non renseigné
    </div>
    <div class="required" v-if="classified.profil_email && !isValidEmail(classified.profil_email)">
      L'email n'est pas valide.
    </div>
    <!-- .form-container -->
  </div>
  <!-- .contact-selector -->
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "contact-selector",
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { contactFocused: false };
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getSettings"]),
  },
  methods: {
		//
  },
};
</script>

<style lang="scss">
.info {
  border: 2px solid rgba(0, 0, 0, 50%);
  border-radius: 50%;
  color: rgba(0, 0, 0, 50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.25rem;
  width: 1.25rem;
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #000;
    color: #fff;
    border-radius: 16px;
    font: 500 0.8rem Source Sans Pro, sans-serif;
    line-height: 1.5;
    padding: 0.5rem;
    max-width: 260px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>
